import { useContext } from 'react'
import { CrmAuthContext } from '../auth-context'

const useCrmCurrentUser = () => {
  const crmAuthContext = useContext(CrmAuthContext)
  return crmAuthContext ?  crmAuthContext.crmCurrentUser : undefined
}

export default useCrmCurrentUser
